/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

// import Logo from '@/assets/pics/logo.svg?react'
import { DELAY } from '@/constants'
import { getLogoByHost } from '@/utils/organisation/getLogoByHost'

import cn from './RegisterSuccess.module.scss'

function RegisterSuccess() {
  const navigate = useNavigate()
  useEffect(() => {
    setTimeout(() => navigate('/'), DELAY * 6)
  }, [])

  const logoPath = getLogoByHost()

  return (
    <section className={cn.success}>
      {/* <Logo /> */}
      <div className={cn.logoContainer}>
        <img loading="lazy" src={logoPath} alt="Логотип" draggable={false} />
      </div>
      <p className={cn.title}>Регистрация пройдена успешно!</p>
    </section>
  )
}

export default RegisterSuccess
